import React, { useState } from "react";
import { FontAwesomeIcon as FA } from "@fortawesome/react-fontawesome";
import SortableList from "./ColumnDropdown";
import TableSchema from "../models/TableSchema";
import "../css/table.css";
import LoadingComponent from "../../component/LoadingComponent";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface ToolbarProps {
  isExportEnabled: boolean;
  onExportTable(): void;
  // columns
  tableSchema: TableSchema;
  allOrderedColumns: string[];
  visibleColumns: string[];
  setColumnsVisibility(visibleColumns: string[]): void;
  setColumnsOrder(orderedColumns: string[]): void;
  // search
  isDisplaySearch: boolean;
  onSearchChanged(searchQuery: string): void;
  searchQuery?: string;
  searchPlaceholder?: string;
}

const Toolbar = ({
  isExportEnabled,
  onExportTable: exportTable,
  // columns
  tableSchema,
  allOrderedColumns,
  visibleColumns,
  setColumnsVisibility,
  setColumnsOrder,
  // search
  isDisplaySearch,
  onSearchChanged,
  searchQuery,
  searchPlaceholder,
}: ToolbarProps): JSX.Element => {
  const [isShowColumnsDropdown, setShowColumnsDropdown] = useState(false);

  return (
    <div className="row flex-grow-1 p-2 border-bottom border-top table-dark">
      <div className="col-6">
        <div className="row">
          <div className="px-3" />

          {/** SEARCH FIELD */}
          {isDisplaySearch && (
            <input
              type="text"
              className="form-control form-control-sm toolbar-search-input"
              placeholder={searchPlaceholder}
              value={searchQuery}
              onChange={(e: React.FormEvent<HTMLInputElement>): void => {
                onSearchChanged(e.currentTarget.value);
              }}
            />
          )}
          {/** END OF SEARCH FIELD */}
        </div>
      </div>

      {/** RIGHT SIDE WITH BUTTONS */}
      <div className="col-6">
        <div className="row dropdown justify-content-end">
          <div className="btn-group">
            {/** COLUMNS BUTTON */}
            <OverlayTrigger
              placement="left"
              delay={{ show: 100, hide: 100 }}
              overlay={<Tooltip id="columns-tooltip">Columns</Tooltip>}
            >
              <button
                className="btn btn-sm border"
                style={{ borderColor: "#1e1f1d" }}
                type="button"
                onClick={(): void => setShowColumnsDropdown(!isShowColumnsDropdown)}
              >
                <FA size="lg" icon="columns" color={isShowColumnsDropdown ? "#28a745" : "#343a40"} fixedWidth />
              </button>
            </OverlayTrigger>
            {/** END OF COLUMNS BUTTON */}

            {/** DROPDOWN WITH COLUMNS */}
            {isShowColumnsDropdown ? (
              <div
                className="dropdown-menu dropdown-menu-right border-1 p-0 show overflow-auto"
                style={{ maxHeight: "32rem", borderColor: "#1e1f1d" }}
              >
                <SortableList
                  tableSchema={tableSchema}
                  allOrderedColumns={allOrderedColumns}
                  visibleColumns={visibleColumns}
                  setVisibleColumns={setColumnsVisibility}
                  setColumnsOrder={setColumnsOrder}
                />
              </div>
            ) : (
              ""
            )}
            {/** END OF DROPDOWN WITH COLUMNS */}
          </div>
        </div>
      </div>
      {/** END OF RIGHT SIDE WITH BUTTONS */}
    </div>
  );
};
export default Toolbar;
